import styled from "styled-components";

export const HelperResponsivo = styled.div`
  
    min-width:80%;
  

  @media (max-width: 600px) {
    zoom:65%;
  }
`;